import { INTEGRATION_PROVIDERS } from '@vy/types';
import { useActivatedIntegration } from '../../../use-activated-integration';

export function useCanConnectNetSuite() {
  return useActivatedIntegration(INTEGRATION_PROVIDERS.netSuite, {
    suspense: true,
  });
} 